import { insertImage, getAtomicEntityInfo, deprecated } from "lib/helpers";
import { ImageBlock } from "./ImageBlock";
import { InsertImageButton } from "./InsertImageButton";
import { createToolbarButtons } from "../createToolbarButtons";
import { extname } from "lib/helpers";
import { RichUtils } from "draft-js";

const DEFAULT_IMAGE_EXT = ['.png', '.jpg', '.jpeg', '.gif'];

const defaultOptions = {
	/**
	 * 工具栏按钮
	 */
	buttons: ['image'],

	/**
	 * 上传之前可以对文件进行处理，如果返回 null，上传取消
	 * @param {File} file
	 */
	beforeUpload(file) {
		return file;
	},

	/**
	 * 处理文件上传
	 * @param {File} file
	 */
	handleUpload(file) {
		const error = new Error('使用 createImagePlugin() 支持图片插入时，必须传入 handleUpload() 方法来实现图片的上传');
		console.error(error);
		throw error;
	},

	/**
	 * 检查 origin 是否允许访问
	 * @param {string} origin
	 */
	checkAllowAccessOrigin(origin) {
		return false;
	},

	/**
	 * 检查文件扩展名是否合法的图片扩展名
	 * @param {string} extName
	 */
	checkAllowExtension(extName) {
		extName = String(extName).toLowerCase();
		return DEFAULT_IMAGE_EXT.includes(extName);
	},

	/**
	 * 上传的最大文件尺寸限制，默认为 2.4 M
	 */
	imageSizeLimit: 2.4 * 1024 * 1024,
};

const BUTTON_MAP = {
	image: InsertImageButton,
}

/**
 * @returns {DraftEditorPlugin}
 */
export function createImagePlugin(options = defaultOptions) {
	const {
		buttons,
		beforeUpload,
		handleUpload,
		imageSizeLimit,
		checkAllowAccessOrigin,
		checkAllowExtension,
		findScrollParent,
	} = { ...defaultOptions, ...options };

	if (findScrollParent) {
		deprecated('图片的懒加载已改由 focusPlugin 支持，请改在 focus 配置项传入');
	}

	const getImageFile = (/** @type {Blob[])}*/ files) => {
		for (let file of files) {
			if (file instanceof File) {
				if (checkAllowExtension(extname(file.name))) {
					return file;
				}
			}
			else {
				if (/image\/(\w+)$/.test(file.type)) {
					return new File([file], 'image.' + RegExp.$1);
				}
			}
		}
		return null;
	};

	const performUpload = (store, files) => {
		let file = getImageFile(files);
		if (!file) {
			return 'not-handled';
		}
		file = beforeUpload(file);
		if (!file) {
			return 'not-handled';
		}
		insertImage({
			file,
			store,
			imageSizeLimit,
			uploadImage: handleUpload,
		});
	}

	return {
		getToolbarButtons(props) {
			if (props.env !== 'root') {
				return null;
			}
			const editorState = props.store.getEditorState();
			// 代码块不支持图片
			if (RichUtils.getCurrentBlockType(editorState) === 'code-block') {
				return null;
			}
			return createToolbarButtons(BUTTON_MAP, buttons, {
				...props,
				onInsert: files => performUpload(props.store, files),
			});
		},
		handleFiles(store, selection, files, type) {
			return performUpload(store, files);
		},
		getBlockRenderInfo(block, store) {
			const entityInfo = getAtomicEntityInfo(block, store);
			if (entityInfo && entityInfo.entityType === 'IMAGE') {
				return {
					component: ImageBlock,
					editable: false,
					props: {
						...entityInfo,
						store,
						checkAllowAccessOrigin,
						imageSizeLimit,
						uploadImage: handleUpload,
					},
				};
			}
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/createImagePlugin.js